import React from 'react';
import './hr.scss';

const Hr = () => {
    return <hr className="hr" />;
};

export default Hr;
